<template>
    <v-container class="mt-3">
        <v-layout row wrap justify-center align-center>
            <v-flex xs12 lg10 xl8 pt-2>

                <v-card flat hover>
                    <v-card-title>
                        <h2 class="title font-weight-light">Encabezado</h2>
                        <v-spacer></v-spacer>
                        <v-text-field
                                outline
                                small
                                hide-details
                                style="max-width: 250px"
                                v-model="expirationDate"
                                label="Válido hasta"
                                readonly
                        ></v-text-field>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text v-show="showUserData">
                            <v-form ref="userData">
                                <v-layout row wrap justify-center>
                                    <v-flex xs12 md11>
                                        <v-layout wrap>
                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. 11.111.111-1"
                                                        prepend-inner-icon="fas fa-id-card"
                                                        clearable
                                                        label="RUT"
                                                        :readonly="readonly.clientDni"
                                                        v-model="templateData.dni"
                                                        :rules="[rules.requerido, rules.rut]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. Juan"
                                                        prepend-inner-icon="fas fa-user"
                                                        clearable
                                                        label="Nombre"
                                                        :readonly="readonly.name"
                                                        v-model="templateData.first_name"
                                                        :rules="[rules.requerido]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. Perez"
                                                        prepend-inner-icon="fas fa-user"
                                                        clearable
                                                        label="Apellido Paterno"
                                                        :readonly="readonly.lastName"
                                                        v-model="templateData.last_name"
                                                        :rules="[rules.requerido]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. Lopez"
                                                        prepend-inner-icon="fas fa-user"
                                                        clearable
                                                        label="Apellido Materno"
                                                        :readonly="readonly.motherName"
                                                        v-model="templateData.mother_last_name"
                                                        :rules="[rules.requerido]"
                                                ></v-text-field>
                                            </v-flex>

                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. juanperez@mail.com"
                                                        prepend-inner-icon="fas fa-envelope"
                                                        clearable
                                                        label="Email"
                                                        :readonly="readonly.clientEmail"
                                                        v-model="templateData.email"
                                                        :rules="[rules.requerido, rules.email]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. Av. calle larga 123"
                                                        prepend-inner-icon="fas fa-street-view"
                                                        clearable
                                                        label="Dirección"
                                                        :readonly="readonly.address"
                                                        v-model="templateData.address"
                                                        :rules="[rules.requerido]"
                                                ></v-text-field>
                                            </v-flex>
                                            <v-flex xs12 md6 pa-1>
                                                <v-autocomplete
                                                        placeholder="Ej. Santiago"
                                                        prepend-inner-icon="fas fa-map-marker-alt"
                                                        clearable
                                                        :items="communes"
                                                        item-text="name"
                                                        item-value="id"
                                                        label="Comuna"
                                                        :readonly="readonly.commune"
                                                        v-model="templateData.commune_id"
                                                        :rules="[rules.requerido]"
                                                ></v-autocomplete>

                                            </v-flex>
                                            <v-flex xs12 md6 pa-1>
                                                <v-text-field
                                                        placeholder="Ej. 56998765432"
                                                        prepend-inner-icon="fas fa-phone"
                                                        clearable
                                                        label="Teléfono 1"
                                                        :readonly="false"
                                                        v-model="templateData.phone1"
                                                        :rules="[rules.requerido, rules.largo]"
                                                        mask="# #### ####"
                                                ></v-text-field>
                                            </v-flex>
                                        </v-layout>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    <v-flex xs12 text-xs-center pb-3>
                        <v-btn @click="showUserData=!showUserData" color="transparent" depressed>
                            <v-icon color="secondary">{{showUserData ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}}</v-icon>
                        </v-btn>
                    </v-flex>
                </v-card>

                <v-card flat hover class="mt-2">
                    <v-card-title>
                        <h2 class="title font-weight-light">Detalle</h2>
                        <v-spacer></v-spacer>
                            <v-btn color="secondary" small outline @click="addNewItem('registrado')" v-if="!template.min_discount_locked">
                                Añadir Servicio
                            </v-btn>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <v-layout wrap justify-center align-center pa-3>
                            <v-flex xs12>
                                <v-alert :value="validationAlert" type="error" outline>Presupuesto presenta errores </v-alert>
                            </v-flex>
                            <v-flex xs12 v-if="items && items.length === 0" text-xs-center pa-3>
                                <span class="caption">Aun no se han agregado items</span>
                            </v-flex>
                            <template v-for="(item, i) in items">
                                <v-flex xs3 md1 pa-1 :key="i + 'a'" style="position:relative;">
                                    <v-text-field
                                            hide-details
                                            label="Cantidad"
                                            v-model="item.qty"
                                            :readonly="template.min_discount_locked"
                                            @blur="item.qty < 1 ? (item.qty = 1) : (item.qty = item.qty)"
                                    ></v-text-field>
                                    <span v-if="!validLines[i]" class="error-line"></span>
                                </v-flex>
                                <v-flex xs9 md4 pa-1 :key="i + 'b'">
                                    <v-autocomplete
                                            :items="servicesItemsProxy"
                                            :disabled="!!item.id && isFromTemplate"
                                            item-text="fullName"
                                            return-object
                                            hide-details
                                            autofocus
                                            label="Descripción"
                                            placeholder="Nombre del servicio"
                                            v-model="item.description"
                                            @change="serviceItemChanged(i)"
                                    ></v-autocomplete>
                                </v-flex>
                                <v-flex xs2 md2 pa-1 :key="i + 'c'">
                                    <v-text-field
                                            hide-details
                                            label="Descuento"
                                            suffix="%"
                                            :readonly="template.min_discount_locked"
                                            v-model.number="item.discount"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4 md2 pa-1 :key="i + 'd'">
                                    <v-text-field
                                            hide-details
                                            label="Precio"
                                            prefix="$"
                                            readonly
                                            v-model="item.price"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4 md2 pa-1 :key="i + 'e'">
                                    <v-text-field
                                            hide-details
                                            label="Total"
                                            prefix="$"
                                            readonly
                                            :value="
                                              calculatedTotal(
                                                item.price,
                                                item.qty,
                                                item.discount
                                              ).toLocaleString('es')
                                            "
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs2 md1 :key="i + 'z'" class="text-xs-center">
                                    <v-btn
                                            icon
                                            @click="removeItem(i)"
                                            :disabled="!!item.id && isFromTemplate"
                                    >
                                        <v-icon size="18" color="error">fas fa-times</v-icon>
                                    </v-btn>
                                </v-flex>
                                <v-flex xs12 :key="i + 'f'" class="hidden-md-and-up">
                                    <v-divider class="my-2"></v-divider>
                                </v-flex>
                            </template>
                        </v-layout>
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-text>
                        <v-layout wrap align -center>
                            <v-flex xs12 md9 pa-1>
                                <v-textarea
                                        outline
                                        label="Comentarios"
                                        :rows="4"
                                        v-model="comments"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs12 md2 px-1 >
                                <v-layout wrap justify-start>
                                    <v-flex xs12>
                                        <v-text-field
                                                readonly
                                                outline
                                                prefix="$"
                                                label="Total Impuesto"
                                                :value="calculatedTaxes.toLocaleString('es')"
                                                hide-details
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 mt-1>
                                        <v-text-field
                                                readonly
                                                outline
                                                prefix="$"
                                                label="Total del Presupuesto"
                                                :value="totalPriceWithTaxes"
                                        ></v-text-field>
                                    </v-flex>
                                </v-layout>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                </v-card>

            </v-flex>
        </v-layout>

        <v-dialog v-model="addServiceModal" max-width="400px" persistent>
            <v-card>
                <add-service
                        :mustQuote="true"
                        @added="addNewServiceFromModal"
                        @close="addServiceModal = false"
                ></add-service>
            </v-card>
        </v-dialog>

    </v-container>
</template>
<script>
    import {VMoney} from 'v-money'
    import {email, largo} from '@/utils/Validators'
    import {rutValidator, rutFormat} from '@/utils/Common'
    export default {
        props: {
            template: {
                type: Object
            },
            servicesItems: {
                type: Array,
                default: () => []
            },
            isFromTemplate: {
                type: Boolean,
                default: false
            }
        },
        components: {
                AddService: () => import('@/components/providers/services/AddService'),
                CommuneSelector: () => import ('@/components/common/CommuneSelector')
        },
        data(){
            return {
                showUserData: true,
                tableHeaders: [
                    {text: 'Cantidad', value: 'qty'},
                    {text: 'Descripción', value: 'description'},
                    {text: '% Descuento', value: 'discount'},
                    {text: 'Precio', value: 'price'},
                    {text: 'Acciones', value: 'none', sorteable: false}
                ],
                items: [],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: '',
                    precision: 0,
                    masked: false /* doesn't work with directive */
                },
                expirationDate: '',
                expirationDateMenu: false,
                actions: [
                    {title: 'Añadir Nuevo Servicio', type: 'nuevo'},
                    {title: 'Añadir un Servicio Registrado', type: 'registrado'}
                ],
                readonly: {},
                templateData: {},
                validLines: [],
                validationAlert: false,
                addServiceModal: false,
                servicesItemsProxy: [],
                comments: '',
                rules: {
                    requerido: val => !!val || 'Campo Obligatorio',
                    rut: val => rutValidator(val) || 'Rut no válido',
                    largo: val => largo(val, 9, 9) || 'Teléfono no válido',
                    isNaN: val => !isNaN(val) || 'Teléfono no válido'
                }
            }
        },
    watch: {
        'templateData.dni':
        function (val) {
            if (val) this.templateData.dni = rutFormat(val)
        }
    },
    computed: {
        totalPrice(){
            if (this.items.length > 0) {
                const total = this.items
                        .map(item =>
                                this.calculatedTotal(item.price, item.qty, item.discount)
                        )
                        .reduce((acc, curr) => {
                            return acc + curr
                        })
                return total
            }
            return 0
        },
        communes(){
            return this.$store.getters.communes
        },
        calculatedTaxes(){
            if (this.items.length > 0) {
                const total = this.items.map(item => {
                    const calc = this.calculatedTotal(item.price, item.qty, item.discount)
                    let val = 0
                    if (item.description.taxFree)
                        val = 0
                    else
                        val = calc * 0.19
                    return Math.ceil(val)
                })
                const reduced = total.reduce((acc, curr) => {
                    return acc + curr
                })
                return reduced
            }
            return 0
        },
        totalPriceWithTaxes(){
            const total = this.totalPrice + this.calculatedTaxes
            return total.toLocaleString('es')
        }
    },
    methods: {
        initModal(){
            this.servicesItemsProxy = [...this.servicesItems]
            this.servicesItemsProxy.unshift({
                id: 'Nuevo',
                serviceId: 'Nuevo',
                serviceItemId: 'Nuevo',
                serviceName: 'Nuevo',
                fullName: 'Nuevo',
                price: 0
            })
            this.tax = 0
            this.loadDescriptionComboBox()
            if (this.isFromTemplate) {
                this.templateData = Object.assign({}, this.template.client)
                this.templateData.phone2 ? this.templateData.phone2 : ''
                this.checkReadonly(this.templateData)
                this.expirationDate = this.template.expires_at
            } else {
                this.templateData = {
                    name: '',
                    last_name: '',
                    mother_last_name: '',
                    email: '',
                    dni: '',
                    phone1: '',
                    phone2: '',
                    address: '',
                    commune_id: null
                }
                this.comments = ''
                const days = this.$store.getters.currentUser.service_providers[0].settings.quotation_expiration_days || 15
                this.expirationDate = this.$moment().add(days, 'days').format('YYYY-MM-DD')
                this.$refs.userData.reset()
            }
        },
        loadDescriptionComboBox(){
            this.items = [...this.template.items]
            this.items.forEach(item => {
                this.validLines.push(true)
                if (item.id) {
                    item.description = this.servicesItems.find(
                            el => el.serviceItemId === item.id
                    )
                }
            })
            if (this.template.min_discount_locked) {
                this.items[0].discount = this.template.discount
            }
            this.checkValidity()
        },
        priceFixedFn(price){
            let pr = 0
            if (price) {
                pr = +String(item.price)
                        .split('.')
                        .join('')
            }
            return pr
        },
        calculatedTotal(price, qty = 1, discount = 0){
            const priceInt = +String(price)
                    .split('.')
                    .join('')
            return Math.ceil((priceInt - priceInt * (+discount / 100)) * +qty)
        },
        checkReadonly(data){
            const readonly = {
                name: data['first_name'] == null,
                lastName: data['last_name'] == null,
                motherName: data['mother_last_name'] == null,
                clientEmail: data['email'] == null,
                clientDni: data['dni'] == null,
                phone1: data['phone1'] == null,
                phone2: data['phone2'] == null,
                address: data['address'] == null,
                commune: data['commune_id'] == null
            }
            const keys = Object.keys(readonly)
            keys.forEach(key => (readonly[key] = !readonly[key]))
            this.readonly = readonly
        },
        addNewItem(type){
            this.checkValidity()
            let item = []
            if (type === 'nuevo') {
                item = {
                    qty: 1,
                    description: {
                        description: '',
                        serviceItemId: null,
                        serviceId: null
                    },
                    discount: 0,
                    price: 0
                }
            } else if (type === 'registrado') {
                item = {
                    qty: 1,
                    description: '',
                    discount: 0,
                    price: 0
                }
            }
            this.items.push(item)
            this.validLines.push(true)
        },
        removeItem(index){
            this.items.splice(index, 1)
            this.validLines.splice(index, 1)
        },
        saveQuotation(){
            if (!this.$refs.userData.validate()) {
                this.validationAlert = true
                this.$store.commit('showSnackBar', 'Debe Completar los Datos del Paciente')
                return
            }
            if (this.items.length === 0) {
                this.validationAlert = true
                this.$store.commit('showSnackBar', 'Presupuesto debe tener al menos 1 Servicio')
                return
            }
            if (!this.expirationDate) {
                this.validationAlert = true
                this.$store.commit('showSnackBar', 'Debe establecer fecha de expiración')
                return
            }
            const today = this.$moment()
            const date = this.$moment(this.expirationDate)
            const diff = date.diff(today, 'days')
            if (diff <= 0) {
                this.validationAlert = true
                this.$store.commit('showSnackBar', 'Fecha de expiración debe ser mayor')
                return
            }
            if (this.checkValidity()) {
                this.validationAlert = false

                if (!this.templateData.phone2) this.templateData.phone2 = null
                return {
                    user: this.templateData,
                    items: this.items,
                    comments: this.comments,
                    expirationDate: this.expirationDate
                }
            } else {
                this.validationAlert = true
                this.$store.commit('showSnackBar', 'Revise los Datos del Presupuesto')
                return []
            }
        },
        checkValidity(){
            let allValid = true
            this.validationAlert = false
            const item = {
                qty: 1,
                description: '',
                discount: 0,
                price: 0
            }
            this.items.push(item)
            this.validLines.push(true)
            this.removeItem(this.items.length - 1)
            this.items.forEach((item, i) => {
                if (item.description.id === 'Nuevo') {
                    this.items.splice(i, 1)
                } else {
                    let valid = true
                    if (item.qty < 1) this.items[i].qty = 1
                    if (item.description === '' || !item.description.description)
                        valid = false
                    let discount = +item.discount
                    if (discount === undefined || discount === null) discount = 0
                    if (isNaN(discount) || discount > 100 || discount < 0) valid = false
                    if (!valid) allValid = false
                    this.validLines[i] = valid
                }
            })
            return allValid
        },
        addNewServiceFromModal(event)
        {
            this.checkValidity()
            this.validLines.push(true)
            this.servicesItemsProxy.push(event.description)
            this.items.push(event)
        },
        serviceItemChanged(index){

            if (this.items[index]['description']['serviceId'] === 'Nuevo')
                this.addServiceModal = true
            else
                this.items[index]['price'] = this.items[index]['description']['price']
        },
        cleanItems(){
            this.items = []
            this.templateData = {}
            this.expirationDate = ''
        }
    }
}
</script>
<style scoped>
    .error-line {
        background-color: red;
        width: 20px;
        height: 20px;
        display: block;
        position: absolute;
        z-index: 20;
        top: 0;
        left: 0;
        border-radius: 100%;
        text-align: center;
        color: #fff;
        font-weight: 900;
    }
</style>